var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { EntitySelect } from '../entities/entity-select';
import { useComponentProps } from '../context/component-props-context';
import { EntityTypeSelect } from '../select/entity-type-select';
var cls = classNames('form-field-entity-select');
export var FormFieldEntitySelectDefaultProps = {
  pageSize: 10
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var SelectStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-family: ", ";\n\n    .shp--entity-select__dropdown-indicator {\n      margin-top: 0px;\n    }\n    \n    .shp--entity-select__clear-indicator {\n      margin-top: -2px;\n    }\n\n    .shp--entity-select__menu {\n      z-index: 1000;\n    }\n\n  "], ["\n    font-family: ", ";\n\n    .shp--entity-select__dropdown-indicator {\n      margin-top: 0px;\n    }\n    \n    .shp--entity-select__clear-indicator {\n      margin-top: -2px;\n    }\n\n    .shp--entity-select__menu {\n      z-index: 1000;\n    }\n\n  "])), theme.FONT('app'))
});
// -------- Components -------->
var My = {
  NAME: 'FormFieldEntitySelect',
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Select: styled(EntityTypeSelect)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), SelectStyles),
  SelectEntity: styled(EntitySelect)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), SelectStyles)
};
export var FormFieldEntitySelect = function (props) {
  var componentProps = useComponentProps(My.NAME, FormFieldEntitySelectDefaultProps, props);
  var className = props.className,
    onChange = props.onChange,
    autoFocus = props.autoFocus,
    isMultiple = props.isMultiple,
    value = props.value,
    pageSize = props.pageSize,
    disabled = props.disabled,
    name = props.name,
    data = props.data,
    entityTypeName = props.entityTypeName,
    type = props.type;
  var _a = __read(React.useState([]), 2),
    selectedItems = _a[0],
    setSelectedItems = _a[1];
  var _b = __read(React.useState(null), 2),
    selectedItem = _b[0],
    setSelectedItem = _b[1];
  React.useEffect(function () {
    if (Array.isArray(value)) {
      setSelectedItems(value.map(function (item) {
        return item.entity;
      }));
    } else {
      setSelectedItems([]);
    }
  }, [value]);
  var handleChange = function (option) {
    setSelectedItem(option);
    if (option) {
      onChange({
        value: {
          entity: option,
          label: option.name,
          value: option.id
        },
        mutationValue: option.value
      });
    } else {
      // the new value is empty (select has been cleared)
      onChange({
        value: '',
        mutationValue: ''
      });
    }
  };
  var handleMultipleChange = function (options) {
    setSelectedItems(options);
    if (options) {
      onChange({
        value: options.map(function (option) {
          return {
            entity: option,
            label: option.name,
            value: option.id
          };
        }),
        mutationValue: options.map(function (option) {
          return option.id;
        })
      });
    } else {
      onChange({
        value: [],
        mutationValue: []
      });
    }
  };
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, type === 'linkedMultiple' ? React.createElement(My.Select, {
    entityTypeName: entityTypeName,
    selectedItems: selectedItems,
    onSelect: function (_a) {
      var items = _a.items;
      handleMultipleChange(items);
    }
  }) : React.createElement(My.Select, {
    entityTypeName: entityTypeName,
    selectedItem: selectedItem,
    onSelect: function (_a) {
      var item = _a.item;
      handleChange(item);
    }
  }));
};
FormFieldEntitySelect.cls = cls;
export var FormFieldEntitySelectMultiple = function (props) {
  return React.createElement(FormFieldEntitySelect, __assign({}, props, {
    isMultiple: true
  }));
};
FormFieldEntitySelectMultiple.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;